import {Pager} from "../../domain/model/common";

interface IGetAllClientBrowsingHistoryByClientRequest {
    pager?: Pager;
}
class GetAllClientBrowsingHistoryByClientRequest implements IGetAllClientBrowsingHistoryByClientRequest {
    public pager: Pager;
}

export {
    GetAllClientBrowsingHistoryByClientRequest
}


// WEBPACK FOOTER //
// ./src/presentation/request/client_browsing_history_request.ts